import axios from 'axios'

import { TIMEOUT, BASE_URL } from './config'
import { getMockData } from './mock-data'

const instance = axios.create({
    baseURL: BASE_URL,
    timeout: TIMEOUT,
})

// 设置拦截器
instance.interceptors.request.use(config => {
    return config
})

instance.interceptors.response.use(
    res => {
        return res.data
    },
    err => {
        // 后端不可用时，尝试使用 mock 数据作为备用方案
        const config = err?.config
        if (config?.url) {
            const mockData = getMockData(config.url, config.params)
            if (mockData) {
                console.warn(`[Mock] 后端请求失败，已启用备用数据：${config.url}`)
                return mockData
            }
        }

        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = '请求错误'
                    console.log('请求错误')
                    break
                case 401:
                    err.message = `未授权访问`
                    console.log('未授权访问')
                    break
                default:
                    err.message = '其他错误信息'
                    console.log('其他错误信息')
            }
        }

        return err
    }
)

export default instance
